@if (filterOnlyDocumentSales(document)) {
  <mat-icon class="text-mat-ef-revolution-primary-500" svgIcon="directions_car"></mat-icon>
}

@if (filterService(document)) {
  @if (document?.code?.startsWith('R')) {
    <mat-icon class="text-mat-ef-revolution-primary-500"
    svgIcon="build"></mat-icon>
  }
  @if (document?.code?.startsWith('O')) {
    <mat-icon svgIcon="offer"></mat-icon>
  }
  @if (
    document?.code?.startsWith('L') ||
    document?.code?.startsWith('D') ||
    document?.code?.startsWith('I') ||
    document?.code?.startsWith('T') ||
    document?.code?.startsWith('N') ||
    document?.code?.startsWith('W')
    ) {
    <mat-icon class="text-mat-ef-revolution-primary-500" svgIcon="insert_drive_file"></mat-icon>
  }
  @if (
    document?.code?.startsWith('C') ||
    document?.code?.startsWith('M') ||
    document?.code?.startsWith('N')
    ) {
    <mat-icon class="text-mat-ef-revolution-primary-500" svgIcon="directions_car"></mat-icon>
  }
  @if (
    document?.code?.startsWith('V') ||
    document?.code?.startsWith('F')
    ) {
    <mat-icon class="text-mat-ef-revolution-primary-500" svgIcon="car_ins">
    </mat-icon>
  }
  @if (document?.code?.startsWith('G')) {
    <mat-icon class="text-mat-ef-revolution-primary-500"
    svgIcon="car_insurance"></mat-icon>
  }
}

@if (filterOnlyDocument(document)) {
  @if (
    document?.format === 'jpg' ||
    document?.format === 'jpeg' ||
    document?.format === 'png'
    ) {
    <mat-icon class="text-mat-ef-revolution-primary-500" svgIcon="broken_image">
    </mat-icon>
  }
  @if (document?.format === 'pdf') {
    <mat-icon class="text-mat-ef-revolution-primary-500" svgIcon="pdf_document">
    </mat-icon>
  }
}